(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.event_share__copy').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-url') || window.location.href;

        var showToast = function () {
          var toast = document.createElement('div');
          toast.className = 'copy-toast';
          toast.textContent = 'Link copied';
          document.body.appendChild(toast);
          setTimeout(function () {
            toast.remove();
          }, 2000);
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(showToast);
        } else {
          var ta = document.createElement('textarea');
          ta.value = url;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          try {
            document.execCommand('copy');
            showToast();
          } catch (err) {}
          ta.remove();
        }
      });
    });
  });
})();
